import { useId } from 'react';

/**
 * A dark pickleball paddle (face, edge guard and wrapped handle), drawn in
 * SVG. Point it with CSS `transform: rotate()` on the className.
 * @param {object} props
 * @param {number} props.width - px; height follows the 200×340 artwork
 * @param {string} [props.className]
 * @param {object} [props.style]
 * @returns {JSX.Element}
 */
function PickleballPaddle({ width, className = '', style }) {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  return (
    <svg width={width} height={width * 1.7} viewBox="0 0 200 340" className={className} style={style} aria-hidden="true">
      <defs>
        <linearGradient id={`${uid}-face`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4a5552" />
          <stop offset="55%" stopColor="#262d2b" />
          <stop offset="100%" stopColor="#151918" />
        </linearGradient>
        <linearGradient id={`${uid}-grip`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0d0f0f" />
          <stop offset="50%" stopColor="#2b302f" />
          <stop offset="100%" stopColor="#0d0f0f" />
        </linearGradient>
      </defs>
      <rect x="62" y="210" width="76" height="126" rx="18" fill={`url(#${uid}-grip)`} />
      {[236, 260, 284, 308].map(y => (
        <line key={y} x1="66" y1={y} x2="134" y2={y + 10} stroke="#3a4140" strokeWidth="3" />
      ))}
      <rect x="6" y="6" width="188" height="230" rx="78" fill="#7d8885" />
      <rect x="12" y="12" width="176" height="218" rx="72" fill={`url(#${uid}-face)`} />
      <path d="M40 40 Q100 18 160 40" stroke="#ffffff" strokeOpacity="0.18" strokeWidth="6" fill="none" />
    </svg>
  );
}

export default PickleballPaddle;
